export default {
    data() {
        return {
            isVisibleOnSmallScreens: true,
            isWindowSmall: false,
            isModalOpen: false,
        }
    },

    mounted() {
        /*this.isWindowSmall = window.innerWidth < 1200 ? true : false
        this.isVisibleOnSmallScreens = !this.isWindowSmall
        if (this.isWindowSmall) {
            this.isModalOpen = true
            this.openConfirmationModal()
        }

        $(window).resize(() => {
            this.handleResizing()
        })*/
    },

    unmounted() {
        /*$(window).unbind()
        this.isModalOpen = true*/
    },

    methods: {
        /*handleResizing() {
            if (this.isModalOpen && window.innerWidth > 1200) {
                $('.modal.is-active').removeClass('is-active')
                this.isVisibleOnSmallScreens = true
                this.isModalOpen = false
            } else if (this.isModalOpen) {
                this.isVisibleOnSmallScreens = true
            } else if (! this.isWindowSmall && window.innerWidth < 1200) {
                this.isVisibleOnSmallScreens = false
                this.isModalOpen = true
                //this.openConfirmationModal()
                this.isWindowSmall = true
            } else if (this.isWindowSmall && window.innerWidth > 1200) {
                this.isVisibleOnSmallScreens = true
                this.isWindowSmall = false
            }
        },
        openConfirmationModal() {
            this.$swal.fire({
                text: 'This web app is only a prototype for now which has not been adapted for mobile devices yet, show anyways?',
                onConfirm: () => {
                    this.isVisibleOnSmallScreens = true
                    this.isModalOpen = false
                },
                onCancel: () => {
                    this.isModalOpen = false
                }
            })
        }*/
    }
}